let destinoChatActivo = null;

export const setDestinoChatActivo = (destino) => {
  destinoChatActivo = destino;
};

export const getDestinoChatActivo = () => destinoChatActivo;

export const limpiarDestinoChat = () => {
  destinoChatActivo = null;
};
